import CustomersRepository, {
  UnifiedSearchFilters,
} from "@/core/customers/repositories/CustomersRepository";
import { UnifiedSearchResponse } from "@/core/customers/entities/Customers";

export default class SearchUnifiedUseCase {
  constructor(private readonly customersRepository: CustomersRepository) {}

  async execute(filters: UnifiedSearchFilters): Promise<UnifiedSearchResponse> {
    return await this.customersRepository.searchUnified(filters);
  }
}
